<template>
  <tr v-on:click="$emit('toggle')" style="background-color: #f9f9f9; cursor: pointer; user-select: none">
    <td v-on:click.stop="" class="is-clickable"><input type="checkbox" v-model="model" v-if="isSelectable" /></td>
    <td class="is-clickable">{{ deliveryId }}</td>
    <td class="is-clickable"><template v-if="delivery.deliverymethod"><strong>{{ delivery.deliverymethod.name }}</strong> <i class="fa fa-fw fa-eye-slash" v-if="parseInt(delivery.deliverymethod.internal)"></i><i class="fa fa-fw fa-truck" v-if="parseInt(delivery.deliverymethod.shipit_id)"></i></template>
      <div class="tags-list" v-if="tags.length" style="display: inline-block">
        <span v-for="tag in tags" class="btn btn-info btn-xs btn-titlerow">{{ getTagTitle(tag) }}</span>
      </div>
    </td>
    <td v-if="isShipitEnabled" class="is-clickable">{{ shipitStatus }}</td>
    <td class="is-clickable"><template v-if="delivery.ts && parseInt(delivery.ts, 10) > this.minReasonableTimestamp">{{ $filters.timestampToDate(delivery.ts) }}</template><template v-else>{{ _('Immediate') }}</template></td>
    <td class="is-clickable">{{ deliveryStatus }}</td>
    <td class="is-clickable">{{ deliveryItemCount }}</td>
  </tr>
</template>

<script>
import components from '~/lib/components'
import settingshelpers from '~/lib/settingshelpers'

export default {
  data () {
    return {
      minReasonableTimestamp: 1000000000
    }
  },
  props: ['value', 'delivery', 'order'],
  mixins: [components, settingshelpers],
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    isSelectable () {
      if (!this.delivery || parseInt(this.delivery.processed) || this.delivery.shipit_status) {
        return false
      }
      return true
    },
    deliveryId () {
      if (!this.delivery || !parseInt(this.delivery.id)) {
        return ''
      }
      return this.delivery.id
    },
    deliveryStatus () {
      if (!this.delivery || !parseInt(this.delivery.processed)) {
        return this._('Not processed')
      }
      return this._('Processed')
    },
    shipitStatus () {
      if (!this.delivery || !this.delivery.shipit_status) {
        return this._('No shipment')
      }
      // @todo process various Shipit statuses
      return this.delivery.shipit_status
    },
    deliveryItemCount () {
      if (!this.order || !this.order.ownItem || !this.delivery) {
        return 0
      }
      return this.order.ownItem.filter(i => i.delivery_id === this.delivery.id).length
    },
    tags () {
      return this.delivery && this.delivery.sharedTag ? this.delivery.sharedTag.filter(t => t.title) : []
    }
  },
  methods: {
    getTagTitle(tag) {
      if (!tag || !tag.title) {
        return ''
      }
      const parts = tag.title.split(':::')
      return parts.pop()
    }
  }
}
</script>

<style scoped>
.btn-titlerow {
  display: inline-block;
  padding: 0px 9px 0px 9px !important;
  margin-left: 4px;
}
</style>